import { marketplacesEnum } from '../../../utils/marketplaces';
import { api } from '../../../plugins/axios';
export default class RepricingRule {
	id = undefined;
	name = undefined;
	condition = undefined;
	compete_rate = undefined;
	include_commission = undefined;
	margin_percentage = undefined;
	marketplaces = undefined;
	has_all_variants = false;
	include_commission = false;
	order = undefined;
	variants = [];
	variants_count = [];

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
		this.variants = this.variants.map((variant) => variant.id);
	}

	get productsCount() {
		return this.variants_count;
	}

	static async getList(params) {
		const res = await api.get('/repricing-rules', { params });
		const data = res.data.result.repricing_rules.data.map((rule) => new RepricingRule(rule));
		const totalRecords = res.data.result.repricing_rules.total;
		data.sort((a, b) => a.order - b.order);
		return {
			data,
			totalRecords,
		};
	}

	static async getById(id) {
		const res = await api.get(`/repricing-rules/${id}`);
		const data = res.data.result.repricing_rule;
		return new RepricingRule(data);
	}

	static async changeOrder(new_order) {
		return api.post('/reorder-repricing-rules', { new_order });
	}

	static async create(data) {
		const res = await api.post('/repricing-rules', data);
		return new RepricingRule(res.data.result?.repricing_rule);
	}

	async update(data) {
		const res = await api.put(`/repricing-rules/${this.id}`, data);
		const newOne = new RepricingRule(res.data.result?.repricing_rule);
		Object.assign(this, newOne);
	}

	async remove() {
		return api.delete(`/repricing-rules/${this.id}`);
	}
}

export const ruleTypeEnum = Object.freeze({
	MatchBuyBox: 'MATCH_BUY_BOX_PRICE',
	MatchLowestPrice: 'MATCH_LOWEST_PRICE',
	CompeteBuyBox: 'COMPETE_BUY_BOX_PRICE',
	CompeteLowestPrice: 'COMPETE_LOWEST_PRICE',
});

export const supportedMarketplaces = [marketplacesEnum.Amazon, marketplacesEnum.Noon];
